import React, { useState, useEffect } from 'react';
import BASE_URL from "../../../../config/config";
import { useNavigate, useLocation } from 'react-router-dom';
import AgreementNotificationService from "../../Controller/AgreementNotificationController";
import HelpSite from "../../../Common/HelpLink";
import AgreementService from "../../Controller/AgreementController";
function AgreementLogPage({ AgreementID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [AgreementLogList, setAgreementLog] = useState([]);
    const CompanyID = localStorage.getItem("CompanyID");
    const [isClosed, SetIsClosed] = useState("0");
    const fetchAgreementLog = async () => {
        try {
            const data = await AgreementNotificationService.GetAllAgreementLog(AgreementID);
            setAgreementLog(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    const fetchAgreementDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (AgreementID > 0) {
                const agreementDetail = await AgreementService.GetAgreementByID(redirectCallback, AgreementID);
                if (agreementDetail[0].FK_Issue_ID > 0 || agreementDetail[0].FK_SalesOrder_ID > 0) {
                    SetIsClosed("1");
                }

            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchAgreementDetail();
        if (AgreementID > 0) {
            fetchAgreementLog();
        }
        else {
            setAgreementLog([])
        }
    }, [AgreementID]);

    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-3">

                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Subject</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AgreementLogList.map((log) => (
                                    <tr key={log.ID}>
                                        <td>{log.LogDate}</td>
                                        <td>{log.vc_from}</td>
                                        <td>{log.vc_to}</td>
                                        <td>{log.vc_subject}</td>
                                        <td>{log.vc_body}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default AgreementLogPage;
